import { ExpandedState } from "@tanstack/react-table";
import { useCallback, useMemo } from "react";
import { ViewTableHandle } from "./ViewTable";

interface Params {
    expanded: ExpandedState;
    tableRef: React.RefObject<Pick<
        ViewTableHandle,
        "expandAll" | "collapseAll"
    > | null>;
}

export const useToggleAllExpansion = ({ expanded, tableRef }: Params) => {
    const isAllCollapsed = useMemo(
        () => Object.keys(expanded).length === 0,
        [expanded],
    );

    const toggleAll = useCallback(() => {
        if (isAllCollapsed) {
            tableRef.current?.expandAll();
        } else {
            tableRef.current?.collapseAll();
        }
    }, [isAllCollapsed, tableRef]);

    return { isAllCollapsed, toggleAll };
};
